import 'babel-polyfill' // 让IE支持es6
import Vue from 'vue';
import store from './store'
import App from './App';
import { router } from './router';
import Vant from 'vant';
import '@/assets/css/common.less' // global css
import 'vant/lib/index.css'; // vant css
import Components from '@/components' // 全局组件
import directive from './directive'
import './permission' // permission control
import PageMixin from "@/mixins/PageMixin"; // 全局混入
import request from "@/utils/request"
import { getDicts } from "@/api/common";
import VConsole from "vconsole"; // 调试器

Vue.prototype.getDicts = getDicts

// 开发环境和正式发布环境不加载调试工具
if (process.env.VUE_APP_ENV === 'development'||process.env.VUE_APP_ENV === 'production') {
  new VConsole();
}

Vue.use(Vant);
Vue.use(Components);// 全局组件挂载
Vue.use(directive) // 指令
Vue.mixin(PageMixin)
Vue.prototype.$request = request

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
